<template>
	<div>我是鉴权页面</div>
</template>

<script>
import request from '@/utils/request';

export default {
	created() {
		// this.useBusinessToken();
	},
	methods: {
		useBusinessToken() {
			let that = this;
			const { order_id, company_id } = this.$route.query;
			const loading = this.$loading({
				lock: true,
				text: "Loading",
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.7)"
			});
			return request({
				url: "/Api/contract/useBusinessToken",
				method: "POST",
			})
				.then(res => {
					loading.close();
					if (res.code != 0) {
						that.$message({
							type: "error",
							message: res.msg || res.message,
						});
						return null;
					}
					const { check } = res.data;
					if (check) {
						that.$router.push({
						name: 'leaseContract.mobile',
						query: {
							order_id,
							company_id,
						},
					});
					}
				})
				.catch(err => {
					loading.close();
					that.$message({
						type: "error",
						message: err.msg || err.message
					});
				});
		},
	}
}
</script>

<style>

</style>